export default {

	referenceCodeToReferenceMap(state) {
		let map = new Map();

		state.references && state.references.forEach(
			ref => map.set(ref.code, ref)
		);

		return map;
	}
};
